// The names must match the permission exactly as seen in Permissions.cs
export const permissionRefs = {
    CanLoginWithoutCrmLink: "CanLoginWithoutCrmLink"
}